// ============================================================
// Pay Rocky — Public Layout + Footer
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

export function PublicLayout({ children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--clr-border)',
      padding: '2rem 1.5rem',
      marginTop: '4rem',
      background: 'rgba(255, 255, 255, 0.65)',
    }}>
      <div className="site-footer-grid" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
      }}>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '15px', marginBottom: '4px', color: 'var(--clr-text)' }}>
            Pay Rocky
          </div>
          <div style={{ fontSize: '12px', color: 'var(--clr-text-3)' }}>
            © {new Date().getFullYear()} LordRock Icon Ltd. All rights reserved.
          </div>
        </div>

        <div className="site-footer-links" style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
          {[
            { label: 'Buy Crypto',  to: '/buy' },
            { label: 'Sell Crypto', to: '/sell' },
            { label: 'Live Rates',  to: '/rates' },
            { label: 'FAQ',         to: '/faq' },
            { label: 'Contact',     to: '/contact' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
            { label: 'Terms & Conditions', to: '/terms-and-conditions' },
          ].map(({ label, to }) => (
            <Link key={to} to={to} style={{ fontSize: '13px', color: 'var(--clr-text-3)', transition: 'color 0.15s' }}>
              {label}
            </Link>
          ))}
        </div>

        <div className="site-footer-note" style={{ fontSize: '12px', color: 'var(--clr-text-3)', textAlign: 'right' }}>
          <div>All transactions verified manually.</div>
          <div>Crypto trading involves risk.</div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .site-footer-grid {
            align-items: flex-start !important;
          }

          .site-footer-links {
            gap: 0.9rem !important;
          }

          .site-footer-note {
            text-align: left !important;
            width: 100%;
          }
        }
      `}</style>
    </footer>
  );
}

/* ── Dashboard Layout (for user & admin) ─────────────────────── */
export function DashboardLayout({ children, sidebar }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex' }}>
      {sidebar}
      <main style={{ flex: 1, overflow: 'auto', background: 'transparent' }}>
        {children}
      </main>
    </div>
  );
}

/* ── Page wrapper for public pages ───────────────────────────── */
export function PageContainer({ children, style = {} }) {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2.5rem 1.5rem',
      ...style,
    }}>
      {children}
    </div>
  );
}

/* ── Section heading ─────────────────────────────────────────── */
export function SectionHeading({ tag, title, subtitle }) {
  return (
    <div style={{ marginBottom: '2.5rem' }}>
      {tag && (
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '4px 12px',
          borderRadius: '99px',
          background: 'var(--clr-accent-dim)',
          border: '1px solid var(--clr-accent-glow)',
          color: 'var(--clr-accent)',
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          marginBottom: '14px',
        }}>
          <span className="pulse-dot" style={{ width: '5px', height: '5px' }} />
          {tag}
        </div>
      )}
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(1.6rem, 4vw, 2.6rem)',
        fontWeight: 800,
        lineHeight: 1.15,
        letterSpacing: '-0.03em',
        marginBottom: '10px',
        color: 'var(--clr-text)',
      }}>
        {title}
      </h1>
      {subtitle && (
        <p style={{ fontSize: '15px', color: 'var(--clr-text-2)', maxWidth: '540px', lineHeight: 1.7 }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
